import Cookies from "js-cookie";

export interface CognitoTokens {
  id_token: string;
  access_token?: string;
}

let refreshPromise: Promise<CognitoTokens | null> | null = null;

export function refreshCognitoTokens(
  backendHost: string,
  refreshToken: string,
  cognitoUsername: string
): Promise<CognitoTokens | null> {
  if (refreshPromise) {
    return refreshPromise;
  }

  refreshPromise = (async (): Promise<CognitoTokens | null> => {
    try {
      const body = new URLSearchParams();
      body.append("refresh_token", refreshToken);
      body.append("sub", cognitoUsername);

      const resp = await fetch(`${backendHost}/api/cognito/refresh`, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString(),
      });

      if (!resp.ok) return null;

      const tokens = await resp.json();
      if (!tokens?.id_token) return null;

      Cookies.set("id_token", tokens.id_token, { expires: 1, secure: true, sameSite: "Strict" });
      if (tokens.access_token) {
        Cookies.set("access_token", tokens.access_token, { expires: 1, secure: true, sameSite: "Strict" });
      }

      return tokens;
    } catch {
      return null;
    }
  })().finally(() => {
    refreshPromise = null;
  });

  return refreshPromise;
}

export function extractCognitoUsername(): string | null {
  const idToken = Cookies.get("id_token");
  if (!idToken) return null;
  try {
    const payload = JSON.parse(atob(idToken.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
    return payload["cognito:username"] ?? payload.sub ?? null;
  } catch {
    return null;
  }
}
